import { render, staticRenderFns } from "./complex-select.vue?vue&type=template&id=4c1d15a7&scoped=true&"
import script from "./complex-select.vue?vue&type=script&lang=js&"
export * from "./complex-select.vue?vue&type=script&lang=js&"
import style0 from "./complex-select.vue?vue&type=style&index=0&id=4c1d15a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1d15a7",
  null
  
)

export default component.exports